// extracted by mini-css-extract-plugin
export var footer = "_p0-0";
export var inherit = "_p0-1";
export var input = "_p0-2";
export var modalContent = "_p0-3";
export var quillEditor = "_p0-4";
export var subtitle = "_p0-5";